<ul class="unordered--padding-inline-start">
  <li class="unordered--li-marker feature-detail-second-color" *ngFor="let item of listItem">{{item}}</li>
</ul>
